export default {
  fields: {
    code: 'Codice',
    tag: 'Tag',
    type: 'Tipo',
    discount_type: 'Tipo di sconto',
    discount: 'Sconto',
    usage_threshold: 'Soglia di utilizzo',
    quantity: 'Quantità',
    expires_at: 'Scadenza',
    customers: 'Clienti',
    purchases: 'Ordini',
    sales: 'Vendite',
    level: 'Livello',
    max_discount: 'Sconto massimo',
  },
  tags: {
    master: 'Master',
    campaign: 'Campagna',
    one_time: 'Uso singolo',
  },
  types: {
    single_use: 'Uso singolo',
    multi_use: 'Uso multiplo',
    unknown: 'Sconosciuto',
  },
  discount_types: {
    fixed_amount: 'Importo fisso',
    percentage: 'Percentuale',
    unknown: 'Sconosciuto',
  },
  labels: {
    discount: 'Sconto',
    usage_threshold: 'Soglia di utilizzo',
    company: 'Azienda',
  },
  collecting_emails: {
    description:
      'Qui puoi configurare il codice promo monouso generato per i nuovi utenti alla registrazione sul sito.',
  },
  buttons: {
    edit: 'Modifica',
  },
  toasts: {
    successfully_deleted: 'Impostazioni codice promo eliminate con successo',
    failed_to_load_data: 'Caricamento dati non riuscito',
  },
};
